import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface EyebrowProps {
    children: ReactNode
    align?: 'left' | 'center'
    onDark?: boolean
    className?: string
}

// Small uppercase label with hairlines, used above section headings.
export default function Eyebrow({ children, align = 'left', onDark = false, className }: EyebrowProps) {
    return (
        <p
            className={cn(
                'flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.28em]',
                onDark ? 'text-champagne' : 'text-gold',
                align === 'center' && 'justify-center',
                className
            )}
        >
            <span aria-hidden='true' className='h-px w-8 bg-current opacity-50' />
            <span>{children}</span>
            {align === 'center' && <span aria-hidden='true' className='h-px w-8 bg-current opacity-50' />}
        </p>
    )
}
